import React, { useEffect, useState } from 'react';
import { ApiHelper } from '../../common/ApiHelper';
import { Card, CircularProgress } from '@mui/material';

const ImageContainer = ({ link }) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [imageData, setImageData] = useState('');
  const [isNormalImage, setIsNormalImage] = useState(true);

  const openExternalLink = () => {
    if (link && link.url) window.open(link.url);
  };
  const getScreenshot = async (url) => {
    try {
      setIsNormalImage(false);
      setImageLoading(true);
      if (url && url !== '') {
        const response = await ApiHelper.GetScreenshotByUrl(url);
        if (response.status === 200 && response.data) {
          setImageLoading(false);
          setImageData(response.data);
        } else {
          setImageLoading(false);
        //   setIsNormalImage(true);
        }
      } else {
        setImageLoading(false);
       
      }
    } catch (e) {
      setImageLoading(false);
      console.log('error', e);
    }
  };
  useEffect(() => {
    // setIsNormalImage(true);
    if (link && link.linkType === 'Official') {
      getScreenshot(link.url);
    } else {
    }
    // console.log('link',imageData);

  }, [link]);
  return (
    <>
      {link.linkType !== 'Official' && <Card >
        <img
              
                className='screenshotLoader' 
                src={link.url}
                loading="lazy"
              /></Card>}
      {link.linkType === 'Official' && (
        <Card className='screenshotLoader' sx={{position:'relative'}}> 
          {imageLoading ? (
            <div className="screenshotLoader">
              <CircularProgress />
              <span style={{ fontSize: '18px', marginLeft: '10px' }}>Loading Site Preview...</span>
            </div>
          ) : (
            <div onClick={openExternalLink} className="iframe-container" >
              <img
                className="screenshot"
                // style={{ objectFit: 'cover' }}
                src={`data:image/png;base64,${imageData}`}
                loading="lazy"
              />
              <div className="overlay2"></div>
              <div className="overlay"> Visit Website</div>
            </div>
          )}
        </Card>
      )}
    </>
  );
};

export default ImageContainer;
